export const ColorMap = new Map([
    ['#3774FE', '#6BA9FF'],
    ['#56D1FF', '#6BA9FF'],
    ['#8BDC2E', '#70CCAB'],
    ['#46D5B1', '#70CCAB'],
    ['#926BFF', '#AA90F4'],
    ['#DE5CFF', '#AA90F4'],
    ['#FF870F', '#F7A87C'],
    ['#FFC046', '#F7A87C'],
    ['#EE4659', '#F77C7C'],
    ['#F9634A', '#F77C7C'],
    ['#68B7FF', '#68B7FF'],
    ['#C4CDDA', '#A8AAAD'],
]);
